var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mode === 'edit')?_c('Sheet',{on:{"change":function($event){_vm.mode = 'print'}}}):_vm._e(),(_vm.mode === 'print')?_c('Print',{on:{"change":function($event){_vm.mode = 'edit'}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }